/**
 * Security Headers Test Utility
 * Helps test and validate security headers implementation
 */

export const testSecurityHeaders = () => {
  console.log('🛡️ Testing Security Headers...');
  
  // Test if we're running in a secure context
  if (!window.isSecureContext) {
    console.warn('⚠️ App is not running in a secure context (HTTPS)');
    console.warn('⚠️ HSTS and some security features may not work');
  } else {
    console.log('✅ App is running in a secure context (HTTPS)');
  }

  // Test Content Security Policy
  if (window.trustedTypes) {
    console.log('✅ Trusted Types API is available');
  } else {
    console.log('ℹ️ Trusted Types API not available (older browser)');
  }

  // Test if we can access required APIs
  const requiredAPIs = [
    'localStorage',
    'sessionStorage',
    'fetch',
    'WebSocket'
  ];

  requiredAPIs.forEach(api => {
    if (window[api]) {
      console.log(`✅ ${api} API is available`);
    } else {
      console.error(`❌ ${api} API is not available`);
    }
  });

  // Test Firebase APIs
  if (window.firebase) {
    console.log('✅ Firebase SDK is loaded');
  } else {
    console.log('ℹ️ Firebase SDK not detected (may be loaded later)');
  }

  // Test for common security issues
  const securityTests = [
    {
      name: 'HTTPS Protocol',
      test: () => window.location.protocol === 'https:',
      message: 'App should run on HTTPS for security'
    },
    {
      name: 'Secure Context',
      test: () => window.isSecureContext,
      message: 'App should run in a secure context'
    },
    {
      name: 'No Mixed Content',
      test: () => {
        const images = document.querySelectorAll('img');
        return Array.from(images).every(img => 
          img.src.startsWith('https:') || img.src.startsWith('data:') || img.src.startsWith('/')
        );
      },
      message: 'All images should use HTTPS or data URLs'
    }
  ];

  securityTests.forEach(test => {
    try {
      if (test.test()) {
        console.log(`✅ ${test.name}: ${test.message}`);
      } else {
        console.warn(`⚠️ ${test.name}: ${test.message}`);
      }
    } catch (error) {
      console.error(`❌ ${test.name}: Error testing - ${error.message}`);
    }
  });

  console.log('🛡️ Security Headers Test Complete');
};

// Auto-run test in development
if (process.env.NODE_ENV === 'development') {
  // Run test after a short delay to allow app to load
  setTimeout(testSecurityHeaders, 2000);
}

export default testSecurityHeaders;
